import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';

import type { StoreProductFormInput } from '../schemas/store-product-form-schema';

/**
 * The note above the shared gallery on a store product that still has its own featured image,
 * from before that control went away. It stays until cleared here; clearing marks the form dirty
 * and the save bar writes it, since it's this store's field.
 */
export function FeaturedOverrideNotice() {
  const { t } = useTranslation('storeCatalog');
  const form = useFormContext<StoreProductFormInput>();
  if (form.formState.disabled) return t('storePage.media.ownFeatured');
  return (
    <>
      {t('storePage.media.ownFeatured')}{' '}
      <Button
        type="button"
        variant="link"
        size="xs"
        className="h-auto p-0 text-xs"
        onClick={() => form.setValue('featuredMediaId', null, { shouldDirty: true })}
      >
        {t('media.useGallery')}
      </Button>
    </>
  );
}
